<template>
  <div class="container-fluid __windowHeight_">
    <!-- <div class="row h-100"> -->
      <div class="passwordreset_page __100vh_">
        <div class="__maincontent">
          <p><b class="__title">Password Reset</b><br> Type Your New Password in The Box Below</p>
            <form @submit.prevent="passwordcheck">
              <div class="__bottomcontent row m-0">
                <div class="mr-4 passwordvalue">
                  <p class="__subtitle mb-1">Reset Password</p>
                  <b-form-input
                    name="new password"
                    class="__forminput mb-1"
                    placeholder="Enter Your New Password"
                    v-model="form.userPassword"
                    v-bind:type="publicFieldType1"
                    :state="errors.first('new password')  && false"
                    v-validate="'required|verify_password'"/>
                  <div @click="publicToggleType('NEW_PWD')">
                    <img class="passwordvalue__eyesabsolute" src="@/assets/image/eye_slash@2x.png" v-if="publicFieldType1=='password'">
                    <img class="passwordvalue__eyesabsolute open" src="@/assets/image/eye@2x.png" v-if="publicFieldType1=='text'">
                  </div>
                  <p v-if="errors.has('new password')" class="fontstyle__errormsg text-left" style="width:235px">
                    {{ errors.first('new password') }}
                  </p>
                  <p  v-else-if="!form.userPassword" style="font-size: 12px; width:236px">
                    Use 8 or more characters with a mix of small and capital letters, and numbers.
                  </p>
                </div>
                <div class="mr-4 passwordvalue">
                  <p class="__subtitle mb-1">Password Confirmation</p>
                  <b-form-input
                    class="__forminput mb-1"
                    name="confirm password"
                    placeholder="Enter Password Confirmation"
                    v-model="form.userPasswordConfirm"
                    v-bind:type="publicFieldType2"
                    :state="errors.first('confirm password')  && false"
                    v-validate="'required'"/>
                  <div @click="publicToggleType('CONFIRM_PWD')">
                    <img class="passwordvalue__eyesabsolute" src="@/assets/image/eye_slash@2x.png" v-if="publicFieldType2=='password'">
                    <img class="passwordvalue__eyesabsolute open" src="@/assets/image/eye@2x.png" v-if="publicFieldType2=='text'">
                  </div>
                  <p v-if="errors.has('confirm password')" class="fontstyle__errormsg">
                    {{ errors.first('confirm password') }}
                  </p>
                  <p v-else-if="form.userPassword !== form.userPasswordConfirm && form.userPasswordConfirm"
                    class="fontstyle__errormsg">
                    Passwords do not match.
                  </p>
                </div>
                <div class="mt-1">
                  <button class="button__bluesmall py-2 mt-3"
                  style="height: fit-content" type="submit"
                  :disabled="!statusLink"
                  >Save</button>
                </div>
              </div>
            </form>
        </div>
      </div>
    <!-- </div> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ConfigPassword from '@/mixin/getters/config-password'

export default {
  name: 'PasswordReset',
  mixins: [ConfigPassword],
  data () {
    return {
      form: {
        userPassword: '',
        userPasswordConfirm: ''
      },
      params: '',
      statusLink: true
    }
  },
  methods: {
    passwordcheck (e) {
      if (this.form.userPassword === this.form.userPasswordConfirm) {
        return this.handleSubmit()
      }
      e.preventDefault()
    },
    handleSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const payload = {
            userPassword: this.form.userPassword,
            resetcode: this.params
          }
          this.$store.dispatch('auth/RESET_PASS', payload)
        }
      })
    },
    fetchResetpwdLink () {
      const payload = {
        resetcode: this.params
      }
      this.$store.dispatch('auth/CHECK_RESET_PASS', payload)
    },
    resetForm () {
      this.form = {
        userPassword: '',
        userPasswordConfirm: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      auth: 'auth/items',
      error: 'auth/error',
      isLoading: 'auth/isLoading',

      checkResetpwd: 'auth/checkResetpwd',
      errorCheckResetpwd: 'auth/errorCheckResetpwd',
      isLoadingCheckResetpwd: 'auth/isLoadingCheckResetpwd'
    })
  },
  mounted () {
    this.params = this.$route.query.code
    this.fetchResetpwdLink()
  },
  watch: {
    auth (data) {
      if (data) {
        this.$eventHub.$emit('dialog-password-reset', data)
        this.resetForm()
      }
    },
    errorCheckResetpwd (data) {
      if (data) {
        if (data.data && data.data.code === 'LINK-EXPIRED-EXCEPTION') {
          this.statusLink = false
        }
        this.$eventHub.$emit('dialog-password-reset', data.data)
        this.resetForm()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/passwordreset/index.vue